import React, { useState, useEffect, useContext } from "react";
import { StoreContext } from "../../../store/Provider";
import useForm from "../../common/hooks/useForm";

import "./index.css";

function Profile() {
  const [profileEditDisabled] = useState(true);
  const [compProfileEditDisabled] = useState(true);
  const fullName = useForm();
  const designation = useForm();
  const emailId = useForm();
  const jobTitle = useForm();
  const userRole = useForm();
  const orgCodes = useForm();
  const context = useContext(StoreContext);

  useEffect(() => {
    designation.setValue(context.omsUserData?.Designation);
    emailId.setValue(context.omsUserData?.EmailId);
    fullName.setValue(context.omsUserData?.FullName);
    jobTitle.setValue(context.omsUserData?.Jobtitle);
    userRole.setValue(context.omsUserData?.UserRoles);
    orgCodes.setValue(context.omsUserData?.OrgCodes);
  }, []);

  return (
    // <MainLayout>
    <div className="_profileComponent">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 _profileComponentLeft">
            <div>
              {/* <div className="_profileImage">
                <img
                  src={`/${basename}/Assets/Images/profileImage.png`}
                  alt="profileImage"
                />
              </div> */}
              <div className="_profileHeading">
                <h5>{context.omsUserData?.FullName ?? ""}</h5>
                {/* <span onClick={() => setProfileEditDisabled((prev) => !prev)}>
                  <Edit_svg />
                </span> */}
              </div>
              <div className="_profileTable">
                <table>
                  <tbody>
                    <tr>
                      <th>Full Name</th>
                      <th>:</th>
                      <td>
                        <input
                          className="form-control"
                          value={fullName.value}
                          onFocus={fullName.onFocus}
                          onChange={fullName.onChange}
                          disabled={profileEditDisabled}
                          placeholder="Designation"
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>Email ID</th>
                      <th>:</th>
                      <td>
                        <input
                          className="form-control"
                          value={emailId.value}
                          onFocus={emailId.onFocus}
                          onChange={emailId.onChange}
                          disabled={profileEditDisabled}
                          placeholder="Email ID"
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>Designation</th>
                      <th>:</th>
                      <td>
                        <input
                          className="form-control"
                          value={designation.value}
                          onFocus={designation.onFocus}
                          onChange={designation.onChange}
                          disabled={compProfileEditDisabled}
                          placeholder="Designation"
                          // name="designation"
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>Job Title</th>
                      <th>:</th>
                      <td>
                        <input
                          className="form-control"
                          value={jobTitle.value}
                          onFocus={jobTitle.onFocus}
                          onChange={jobTitle.onChange}
                          disabled={compProfileEditDisabled}
                          placeholder="Job Title"
                          // name="contact"
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>User Role</th>
                      <th>:</th>
                      <td>
                        <input
                          className="form-control"
                          value={userRole.value}
                          onFocus={userRole.onFocus}
                          onChange={userRole.onChange}
                          disabled={compProfileEditDisabled}
                          placeholder="User Role"
                          // name="contact"
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>Organisations Code</th>
                      <th>:</th>
                      <td>
                        <input
                          className="form-control"
                          value={orgCodes.value}
                          onFocus={orgCodes.onFocus}
                          onChange={orgCodes.onChange}
                          disabled={compProfileEditDisabled}
                          placeholder="Organisations Code"
                          // name="contact"
                        />
                      </td>
                    </tr>
                    {/* <tr>
                      <th>Contact No.</th>
                      <th>:</th>
                      <td>
                        <input
                          className="form-control"
                          value={contact.value}
                          onFocus={contact.onFocus}
                          onChange={contact.onChange}
                          disabled={profileEditDisabled}
                          placeholder="Contact No."
                        />
                      </td>
                    </tr> */}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {/* <div className="col-md-7 col-12 _profileComponentRight">
            <div>
              <div className="_profileHeading">
                <h5>Company Profile</h5>
                <span
                  onClick={() => setCompProfileEditDisabled((prev) => !prev)}
                >
                  <Edit_svg />
                </span>
              </div>
              <div className="_profileTable">
                <table>
                  <tbody>
                    <tr>
                      <th>Designation</th>
                      <th>:</th>
                      <td>
                        <input
                          className="form-control"
                          value={designation.value}
                          onFocus={designation.onFocus}
                          onChange={designation.onChange}
                          disabled={compProfileEditDisabled}
                          placeholder="Designation"
                          // name="designation"
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>Job Title</th>
                      <th>:</th>
                      <td>
                        <input
                          className="form-control"
                          value={jobTitle.value}
                          onFocus={jobTitle.onFocus}
                          onChange={jobTitle.onChange}
                          disabled={compProfileEditDisabled}
                          placeholder="Job Title"
                          // name="contact"
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>User Role</th>
                      <th>:</th>
                      <td>
                        <input
                          className="form-control"
                          value={userRole.value}
                          onFocus={userRole.onFocus}
                          onChange={userRole.onChange}
                          disabled={compProfileEditDisabled}
                          placeholder="User Role"
                          // name="contact"
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>Organisations Code</th>
                      <th>:</th>
                      <td>
                        <input
                          className="form-control"
                          value={orgCodes.value}
                          onFocus={orgCodes.onFocus}
                          onChange={orgCodes.onChange}
                          disabled={compProfileEditDisabled}
                          placeholder="Organisations Code"
                          // name="contact"
                        />
                      </td>
                    </tr>
                     <tr>
                      <th>Company Name</th>
                      <th>:</th>
                      <td>
                        <input
                          className="form-control"
                          value={"SoftFreight Logic Pvt. Ltd."}
                          disabled={compProfileEditDisabled}
                        />
                      </td>
                    </tr> 
                    <tr>
                      <th>Company Contact</th>
                      <th>:</th>
                      <td>
                        <input
                          className="form-control"
                          value={"Company Contact"}
                          disabled={compProfileEditDisabled}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>Company Email ID</th>
                      <th>:</th>
                      <td>
                        <input
                          className="form-control"
                          value={"Company Email ID"}
                          disabled={compProfileEditDisabled}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>Company Address</th>
                      <th>:</th>
                      <td>
                        <input
                          className="form-control"
                          value={"Company Address"}
                          disabled={compProfileEditDisabled}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>Website</th>
                      <th>:</th>
                      <td>
                        <input
                          className="form-control"
                          value={"Website"}
                          disabled={compProfileEditDisabled}
                        />
                      </td>
              </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div> */}
        </div>
        {/* <div className="row">
          <div className="col-12">
            <button className="_profileApplyButton">APPLY</button>
          </div>
        </div> */}
      </div>
    </div>
    // </MainLayout>
  );
}

export default Profile;
